<div mat-dialog-title></div>
<div class="m-2">
  <h2 class="ap-blue">{{ 'ml_144099' | translate }} {{ title | translate }}</h2>

  <div mat-dialog-content class="m-0">
    <form [formGroup]="editForm" ngxsForm="{{formPath}}" [ngxsFormDebounce]="500" [ngxsFormClearOnDestroy]="true">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144101' | translate}}</mat-label>
            <input matInput placeholder="" formControlName="reportName" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_143912' | translate}}</mat-label>
            <mat-select formControlName="country" [disabled]="processing$ | async">
              @for (item of countrySelectItems; track $index) {
              <mat-option [value]="item.value">
                {{item.label | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144102' | translate}}</mat-label>
            <input matInput placeholder="" formControlName="reportUrl" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_143964' | translate}}</mat-label>
            <textarea matInput placeholder="" formControlName="description" rows="3"></textarea>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="row m-0 p-2 justify-content-end">
    <spinner-button class="me-3 col-auto" [refreshState$]="processing$" [disabled]="editForm.invalid"
      label="{{ 'ml_143934' | translate }}" refreshLabel="{{ 'ml_143923' | translate }}" (clicked)="onOkClick()">
    </spinner-button>
    <button (click)="onCancelClick()" class="button--default button-back col-auto attachment-select">{{ 'ml_143935' |
      translate }}</button>
  </div>
</div>